import React from 'react';
import AccuracyTrendChart from './AccuracyTrendChart';
import SpeedImprovementChart from './SpeedImprovementChart';

interface AdditionalChartsRowProps {
  reportCard: any;
}

const AdditionalChartsRow: React.FC<AdditionalChartsRowProps> = ({ reportCard }) => {
  if (!reportCard) return null;

  return (
    <div className="row g-4 mb-4">
      {/* Accuracy Trend Chart */}
      {reportCard.accuracy_trend_data && Array.isArray(reportCard.accuracy_trend_data) && reportCard.accuracy_trend_data.length > 0 && (
        <div className="col-md-6">
          <div className="card border-0 shadow-sm h-100" style={{ borderRadius: '15px' }}>
            <div className="card-header bg-transparent border-0 pt-4">
              <h5 className="card-title fw-bold mb-0">
                <i className="fas fa-bullseye me-2 text-info"></i>
                Subject-wise Accuracy
              </h5>
              <small className="text-muted">Performance comparison across different subjects</small>
            </div>
            <div className="card-body">
              <AccuracyTrendChart data={reportCard.accuracy_trend_data} />
            </div>
          </div>
        </div>
      )}

      {/* Speed Improvement Chart */}
      {reportCard.speed_improvement_data && Array.isArray(reportCard.speed_improvement_data) && reportCard.speed_improvement_data.length > 0 && (
        <div className="col-md-6">
          <div className="card border-0 shadow-sm h-100" style={{ borderRadius: '15px' }}>
            <div className="card-header bg-transparent border-0 pt-4">
              <h5 className="card-title fw-bold mb-0">
                <i className="fas fa-tachometer-alt me-2 text-warning"></i>
                Speed Trends
              </h5>
              <small className="text-muted">Average time per question over time</small>
            </div>
            <div className="card-body">
              <SpeedImprovementChart data={reportCard.speed_improvement_data} />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdditionalChartsRow;
